import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card__head d-flex align-items-center" }
const _hoisted_2 = { class: "d-flex align-items-center mb-0" }
const _hoisted_3 = { class: "bt-icon bt-icon--sm" }
const _hoisted_4 = { class: "ml-3" }
const _hoisted_5 = { class: "btn-stripped" }
const _hoisted_6 = { class: "btn-stripped text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_Card = _resolveComponent("Card")
  const _component_DialogConfirmDelete = _resolveComponent("DialogConfirmDelete")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, _ctx.$attrs, {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("h4", _hoisted_2, [
            _createVNode("span", _hoisted_3, [
              _createVNode(_component_InlineSvgScoped, {
                src: 
                                require(`@/assets/images/entrancePlants/icon-switchboard.svg`)
                            ,
                "aria-label": "icon-switchboard"
              }, null, 8, ["src"])
            ]),
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.switchboard.name), 1)
          ]),
          (!_ctx.disableOptions)
            ? (_openBlock(), _createBlock(_component_ElDropdown, {
                key: 0,
                class: "ml-auto p-button-text",
                trigger: "click",
                placement: "bottom-end",
                "popper-class": "el-dropdown__popper el-dropdown--context"
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_ElDropdownMenu, { style: {"width":"300px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ElDropdownItem, {
                        disabled: _ctx.disableOptions,
                        onClick: _ctx.handleEditSwitchboard
                      }, {
                        default: _withCtx(() => [
                          _createVNode("button", _hoisted_5, _toDisplayString(_ctx.$t("AppResource.Edit")), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"]),
                      _createVNode(_component_ElDropdownItem, {
                        disabled: _ctx.disableOptions,
                        onClick: _ctx.toggleDeleteSwitchboardConfirm
                      }, {
                        default: _withCtx(() => [
                          _createVNode("button", _hoisted_6, _toDisplayString(_ctx.$t("AppResource.Delete")), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"])
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Button, {
                    label: _ctx.$t('AppResource.More'),
                    class: "ml-auto p-button-text"
                  }, null, 8, ["label"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 16),
    _createVNode(_component_DialogConfirmDelete, {
      "is-visible": _ctx.isVisibleDeleteSwitchboardConfirm,
      title: _ctx.$t('entrancePlant.deleteSwitchboard'),
      message: _ctx.$t('entrancePlant.deleteSwitchboardQuestion'),
      onHideDialog: _ctx.toggleDeleteSwitchboardConfirm,
      onConfirm: _ctx.handleDeleteSwitchboard
    }, null, 8, ["is-visible", "title", "message", "onHideDialog", "onConfirm"])
  ], 64))
}